module.exports = __webpack_public_path__ + "static/media/IMG_1360.d997a57d.jpg";